/*
 * Dropdown selection component
 */

import React from 'react';
import Select from "../../common/Select.jsx";

import {
  Mode,
  castDataType,
  DataType
} from '../common.jsx';

import ReactSelectSelection from './react_select_selection.jsx';


/* 
  Component inheriting must implement option fetching and set the state.options in format: 
  {
    value: <value>,  // Option value
    label: <label>,  // Option label
    indent: <indent> // Option indent, for hierarchial grouping
  }
*/
export default class DropdownSelectionWithAsyncOptions extends ReactSelectSelection {

        static get TYPE() {
            return 'dropdown_selection_with_async_options';
        }

        static get SETTINGS_DUMMY_DATA() {
            return [
                { value: 1, label: 'Example 1' },
                { value: 2, label: 'Example 2' },
                { value: 3, label: 'Example 3' }
            ];
        }

        static icon(){
            return <i className="fa fa-caret-down"></i>;
        }

        static get TRANSLATED_ATTRIBUTES() {
            return {
                label: 'field_default_label',
                description: 'field_default_description',
                help: null,
                blankOptionLabel: 'select_blank_option_default'
            };
        }

        static defaultContent(language) {
            return Object.assign(super.defaultContent(language), {
                includeBlank: false,
                blankOptionLabel: 'blankOptionLabel'
            });
        }

        constructor(props){
            super(props);
            this.selectClicked = this.selectClicked.bind(this);
            // this.selectRef = React.createRef();
            this.state = {
              ...this.state,
              options: [],
              loading: true,
            }
        }

        getFlatOptions() {
          return Object.values(this.state.options).flat();
        }

        getOptions(_) {
          return this.state.options || [];
        }

        renderSettings() {
        }

        renderGroupedOptions() {
          let optionObject = this.getOptions();
          let options = Object.keys(optionObject).sort().map(group => {
            return {
              label: optionObject[group][0].group_label, 
              options: optionObject[group].map((o, i) => (
                { ...o, value: o.value, label: o.label, disabled: o.disabled }
              ))
            }
          })
          return options;
        }

        renderOptions() {
            if (this.state.loading) {
              return this.renderOptionsLoading();
            }

            let options = Array.isArray(this.getOptions()) ? ( 
              this.getOptions().map((o, i) => {
                // return (
                //   <option key={(i + 1) + '-' + o.value} value={o.value} disabled={o.disabled}>{o.label}</option>
                // );
                return {...o, label: o.label, value: o.value, disabled: o.disabled}                
              })
              )
              :
             this.renderGroupedOptions();

            if (this.props.content.includeBlank && !this.props.content.allowMultiple) {
                // options = [<option key={0} value="">{this.getText('blankOptionLabel')}</option>].concat(options);
                options.unshift({label: this.getText('blankOptionLabel'), value: '' })
            }

            // let hiddenValue = null;

            // if (this.isReadOnlyPrefilledAnswer()) {
            //     hiddenValue = <input type="hidden" name={this.fullFieldName()} defaultValue={this.getAnswer()} />
            // }

            let dynamicProps = {};
            if (typeof this.formatOptionLabel == 'function') {
              dynamicProps.formatOptionLabel = this.formatOptionLabel;
            }

            const selected = this.getSelected();

            return (
                <div key="loaded">
                    {(Array.isArray(selected) ? selected : [selected]).map((s) => <input key={s} type="hidden" name={this.fullFieldName(this.props.content.allowMultiple != false)} value={s} />)}
                    <Select
                        key={options.length} // Forces update when options change
                        // name={this.fullFieldName()} 
                        value={selected}
                        autoComplete={this.getAutoComplete()}
                        readOnly={this.props.mode != Mode.FILL}
                        disabled={(this.props.mode == Mode.FILL && this.isReadOnlyAnswer()) || this.props.disabled || this.props.mode == Mode.VIEW}
                        // onMouseDown={this.selectClicked}
                        onChange={this.onChange}
                        className={`${this.isReadOnlyAnswer() ? 'locked' : ''}`}
                        // ref={this.selectRef}
                        options={options}
                        isMulti={this.props.content.allowMultiple || false}
                        styles={this.props.content.disableSingleRemove ? {
                          multiValueRemove: (provided, state) => ({
                            ...provided,
                            display: 'none'
                          })
                        } : {}}
                        {...dynamicProps}
                        autoComplete={this.getAutoComplete()}
                        // isOptionDisabled={(option) => option.disabled}
                    />
                </div>
            );
        }

        renderOptionsLoading() {
          return (
            <div key="loading">
              <select
                disabled
                className={`form-control`}
                autoComplete={this.getAutoComplete()}
              >
                <option>{`${I18n.t('loading')}...`}</option>
              </select>
            </div>
          )
        }

        selectClicked(e) {
            if (this.props.mode != Mode.FILL) {
                e.preventDefault();
                return false;
            }
        }

        beforeUpdateSettings(content) {
            super.beforeUpdateSettings(content);
            content.includeBlank = castDataType(content.includeBlank, DataType.BOOLEAN);

            // Blank option should be included in case the field is required
            if (content.required) {
                content.includeBlank = true;
            }
        }
  
        getFormattedAnswer(answer) {
            // Effectively the selected answer is the first visible option unless a blank option is included
            if (!this.props.content.includeBlank && !this.props.content.allowMultiple && !answer) {
                answer = ((this.getOptions() || [])[0] || {}).value || ''
            }
            return super.getFormattedAnswer(answer);
        }

        getSelectedOptions = (answer) => {
          const selected = super.getSelectedOptions(answer);
          return this.props.content.allowMultiple ? selected : selected[0];
        }

        initSelect2 = () => {
          //Deprecated, uses react-select now
          // Kept here, until inherited components are revised
        }
}
